import React, {useContext} from "react";
import styled from "styled-components";
import tw from "twin.macro";
import {AppContext} from "../App";

const GameOverContainer = styled.div`
  min-width: 320px;

  ${tw`
  flex
  flex-col
  items-center
  justify-center
  h-40
  pb-4
  
  sm:h-48
  md:h-52
  lg:h-52
 
    `}
`

const GameOverStyles = styled.div`
  ${tw`
  h-auto
  flex
  flex-col
  justify-center
  items-center
  uppercase
    
    `}
`

const CorrectAmount = styled.div`
  ${tw`
  text-white
  pb-1
  text-center
  text-4xl
  font-extrabold
  
  sm:text-6xl
  md:text-6xl
  
    `}
`

const CorrectWord = styled.div`
  ${tw`
   text-red-500 
   text-lg
   flex
   flex-col
   text-center
   justify-center
   items-center
   font-bold
   
   sm:text-2xl
    `}
`

const Word = styled.div`
  ${tw`
   text-5xl
   text-green-500 
   font-extrabold
    `}
`

const GuessAmount = styled.div`
  ${tw`
    text-green-500
    
    `}
`

export default function GameOver() {
    const {gameover, setGameover, correctWord, currAttempt} = useContext(AppContext)

    return (
        <>
            <GameOverContainer>
                <GameOverStyles>
                    <CorrectAmount>
                        {gameover.guessedWord ? "Correct!" : "You suck"}
                    </CorrectAmount>

                    <CorrectWord>
                        Correct Word:
                        <Word>
                            {correctWord}
                        </Word>
                    </CorrectWord>
                    <GuessAmount>
                        {gameover.guessedWord && (
                            <div>You guessed in {currAttempt.attempt} attempts</div>)}
                    </GuessAmount>
                </GameOverStyles>
            </GameOverContainer>
        </>
    )
}
